import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import ProtectedRoute from '../components/auth/ProtectedRoute';

const LoginPage = lazy(() => import('../pages/auth/login'));
const SignupPage = lazy(() => import('../pages/auth/signup'));
const ClientRegisterPage = lazy(() => import('../pages/auth/client-register'));
const ResetPasswordPage = lazy(() => import('../pages/auth/reset-password'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const ClientPortalPage = lazy(() => import('../pages/client-portal/page'));
const EmployeePortalPage = lazy(() => import('../pages/employee-portal/page'));
const ReportsPage = lazy(() => import('../pages/reports/page'));
const CatalogPage = lazy(() => import('../pages/catalog/page'));
const PurchaseOrdersPage = lazy(() => import('../pages/purchase-orders/page'));
const CustomersPage = lazy(() => import('../pages/customers/page'));
const InventoryManagementPage = lazy(() => import('../pages/inventory-management/page'));
const VendorsPage = lazy(() => import('../pages/vendors/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const AgreementsPage = lazy(() => import('../pages/agreements/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LoginPage />
  },
  {
    path: '/auth/login',
    element: <LoginPage />
  },
  {
    path: '/auth/signup',
    element: <SignupPage />
  },
  {
    path: '/auth/client-register',
    element: <ClientRegisterPage />
  },
  {
    path: '/auth/reset-password',
    element: <ResetPasswordPage />
  },
  {
    path: '/dashboard',
    element: <ProtectedRoute><DashboardPage /></ProtectedRoute>
  },
  {
    path: '/client-portal',
    element: <ProtectedRoute><ClientPortalPage /></ProtectedRoute>
  },
  {
    path: '/employee-portal',
    element: <ProtectedRoute><EmployeePortalPage /></ProtectedRoute>
  },
  {
    path: '/reports',
    element: <ProtectedRoute requiredRoles={['admin', 'manager']}><ReportsPage /></ProtectedRoute>
  },
  {
    path: '/catalog',
    element: <ProtectedRoute><CatalogPage /></ProtectedRoute>
  },
  {
    path: '/purchase-orders',
    element: <ProtectedRoute requiredRoles={['admin', 'manager']}><PurchaseOrdersPage /></ProtectedRoute>
  },
  {
    path: '/customers',
    element: <ProtectedRoute requiredRoles={['admin', 'manager', 'employee']}><CustomersPage /></ProtectedRoute>
  },
  {
    path: '/inventory-management',
    element: <ProtectedRoute requiredRoles={['admin', 'manager', 'employee']}><InventoryManagementPage /></ProtectedRoute>
  },
  {
    path: '/vendors',
    element: <ProtectedRoute requiredRoles={['admin', 'manager']}><VendorsPage /></ProtectedRoute>
  },
  {
    path: '/settings',
    element: <ProtectedRoute requiredRoles={['admin', 'manager', 'employee']}><SettingsPage /></ProtectedRoute>
  },
  {
    path: '/agreements',
    element: <ProtectedRoute><AgreementsPage /></ProtectedRoute>
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
